import React from "react"
import { Header } from "../components/header/Header"
import { SkillRating } from "../components/skillRating/SkillRating"
import Timeline from "../components/timeline/Timeline"
import { Introducing } from "../components/introducing/Introducing"

import "../css/home.css"
import Footer from "../components/footer/Footer"

export default () => {
  return (
    <div className="home">
      <div className="home__wrapper">
        <Header />
        <div className="home__skills">
          <SkillRating done="80" skill="html & css" />
          <SkillRating done="50" skill="javascript" />
          <SkillRating done="50" skill="react" />
          <SkillRating done="50" skill="gatsby" />
          <SkillRating done="30" skill="shopify" />
        </div>
        <div className="home__introducing">
          <Introducing />
        </div>
        <Footer />
      </div>
    </div>
  )
}
